var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"chart-dialog"},[_c('el-dialog',{attrs:{"title":"学生成绩对比图","visible":_vm.chartDialogShow,"width":"50%","before-close":_vm.dialogClose},on:{"update:visible":function($event){_vm.chartDialogShow=$event}}},[_c('div',{ref:"chart",staticStyle:{"height":"500px","width":"96%","margin":"0 auto"},attrs:{"id":"myChart"}})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }